import { isApiError, NETWORK_ERROR, TOO_MANY_REQUESTS } from './errors';

/**
 * 오류 코드 → 화면 문구 (해요체).
 *
 * 서버 description 은 운영 로그용 합니다체라 화면에 그대로 쓰지 않는다.
 * 문구는 "Navigating error" 원칙 — 무엇이 문제인지와 다음에 할 일을 함께 말한다.
 */
const MESSAGES: Record<string, string> = {
  AUTH_INVALID_CREDENTIALS:
    '이메일 또는 비밀번호가 맞지 않아요. 팬즈드롭 앱에 로그인할 때 쓰는 정보로 다시 입력해 주세요.',
  AUTH_ACCOUNT_NOT_FOUND: '가입된 계정이 없어요. 팬즈드롭 앱에서 가입한 뒤 로그인해 주세요.',
  AUTH_ACCOUNT_DEACTIVATED: '이용이 중지된 계정이에요. 고객센터로 문의해 주세요.',
  AUTH_SOCIAL_AUTH_FAILED: '소셜 계정을 확인하지 못했어요. 다시 시도해 주세요.',
  AUTH_TOKEN_EXPIRED: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_TOKEN_INVALID: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_TOKEN_BLACKLISTED: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_REFRESH_TOKEN_INVALID: '로그인이 만료됐어요. 다시 로그인해 주세요.',
  AUTH_UNAUTHORIZED: '로그인이 필요해요.',
  AUTH_FORBIDDEN: '이 화면을 볼 수 있는 권한이 없어요.',

  COIN_ORDER_PACKAGE_NOT_FOUND: '지금은 팔지 않는 상품이에요. 충전할 코인을 다시 골라 주세요.',
  COIN_ORDER_INVALID_QUANTITY: '충전할 코인을 하나만 골라 주세요.',
  COIN_ORDER_NOT_FOUND: '주문을 찾지 못했어요. 충전 내역에서 확인해 주세요.',
  COIN_ORDER_AMOUNT_MISMATCH: '결제 금액이 주문과 달라요. 처음부터 다시 충전해 주세요.',
  COIN_ORDER_NOT_PAYABLE: '이미 끝난 주문이에요. 처음부터 다시 충전해 주세요.',
  COIN_ORDER_PROCESSING: '결제를 확인하고 있어요. 잠시 후 충전 내역에서 확인해 주세요.',
  COIN_ORDER_EXPIRED: '결제 시간이 지났어요. 처음부터 다시 충전해 주세요.',
  COIN_ORDER_PAYMENT_KEY_MISMATCH: '다른 결제와 섞인 요청이에요. 처음부터 다시 충전해 주세요.',
  COIN_ORDER_INVALID_CURSOR: '목록 위치를 잃었어요. 처음부터 다시 불러와 주세요.',

  PAYMENT_REJECTED: '결제가 승인되지 않았어요. 다른 결제 수단으로 다시 시도해 주세요.',
  PAYMENT_PENDING: '결제를 확인하고 있어요. 잠시 후 충전 내역에서 확인해 주세요.',
  PAYMENT_CONFIG_MISSING: '지금은 결제할 수 없어요. 고객센터로 문의해 주세요.',

  [TOO_MANY_REQUESTS]: '요청이 많아 잠시 쉬어 가요. 조금 뒤에 다시 시도해 주세요.',
  [NETWORK_ERROR]: '인터넷 연결이 불안정해요. 연결을 확인하고 다시 시도해 주세요.',
};

export const DEFAULT_ERROR_MESSAGE = '일시적인 문제가 생겼어요. 잠시 후 다시 시도해 주세요.';
const VALIDATION_ERROR_MESSAGE = '입력한 내용을 다시 확인해 주세요.';

/** 오류를 화면 문구로 바꾼다 */
export function getErrorMessage(error: unknown): string {
  if (!isApiError(error)) return DEFAULT_ERROR_MESSAGE;
  const message = MESSAGES[error.code];
  if (message) return message;
  // class-validator 400 (code 'Bad Request') — 클라이언트 검증을 통과한 뒤라 드문 경우
  if (error.status === 400) return VALIDATION_ERROR_MESSAGE;
  return DEFAULT_ERROR_MESSAGE;
}
